'use client'

import { preloadAssets } from 'lib/asset/preload'
import { usePathname } from 'next/navigation'

export function PreloadAssets() {
  const pathname = usePathname()
  const assets = preloadAssets[pathname] ?? []

  if (assets.length === 0) return null

  return (
    <>
      {assets.map((asset, i) => (
        <link
          key={i}
          rel="preload"
          as={asset.as}
          href={asset.href}
          type={asset.type}
        />
      ))}
    </>
  )
}
